import React from "react";
import "./ourvision.scss";
import { motion } from "framer-motion";

const Ourvision = () => {

  
  const textVariant = {
    hidden: { opacity: 0, y: 60 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut",
      },
    },
  };

  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariant = {
    hidden: { opacity: 0, y: 80 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  };

  return (
    <section className="visionmain" id="platform">
      <span className="leftshade"></span>
      <span className="rightshade"></span>

      <div className="custom-container">

        <div className="innervision">
          
          <motion.div
            className="leftvision"
            variants={textVariant}
            initial="hidden"
            whileInView="show"
            viewport={{ amount: 0.3 }}
          >
            <span className="visionspan">Our Vision</span>

            <motion.h1 className="visionhead" variants={textVariant}>
              A New Standard for Market Transparency
            </motion.h1>

            <motion.p className="visionpara" variants={textVariant}>
              TraqStock is building a trusted environment where public
              companies can publish verified share structure data and
              investors can access transparent insights into market activity.
              By combining verified company data, transparent trading
              intelligence, identity-verified investor discussions, and
              blockchain-anchored records, TraqStock brings greater clarity
              and accountability to public markets.
            </motion.p>
          </motion.div>

          <motion.img
            src="/assets/vision/visionmainimg.png"
            alt="visionmainimg"
            className="visionmainimg img-fluid"
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ amount: 0.3 }}
          />
        </div>

        <motion.div
          className="visioncards"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ amount: 0.2 }}
        >

          <motion.div className="innercard" variants={cardVariant}>
             <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <g clip-path="url(#clip0_397_461)">
                  <path
                    d="M13.3333 12C20.8 12 26.6667 9.33333 26.6667 6C26.6667 2.66667 20.8 0 13.3333 0C5.86667 0 0 2.66667 0 6C0 9.33333 5.86667 12 13.3333 12ZM13.3333 18.6667C15.2 18.6667 17.0667 18.5333 18.6667 18.2667C18.8 18.2667 18.9333 18.1333 18.9333 18.1333C20.5333 16.8 22.5333 16 24.5333 16H24.9333C25.0667 16 25.2 16 25.3333 15.8667C26.1333 15.2 26.5333 14.6667 26.5333 14V10.6667C26.5333 10.4 26.4 10.1333 26.1333 10.1333C25.8667 10 25.6 10 25.4667 10.1333C22.8 12.1333 18.2667 13.3333 13.2 13.3333C8.13333 13.3333 3.73333 12.1333 1.06667 10.1333C0.8 10 0.533333 10 0.4 10.1333C0.133333 10.2667 0 10.4 0 10.6667V14C0 16.2667 5.33333 18.6667 13.3333 18.6667ZM16.4 27.0667C16.2667 26.8 16 26.5333 15.7333 26.5333C14.9333 26.6667 14.1333 26.6667 13.3333 26.6667C8.26667 26.6667 3.73333 25.7333 1.06667 24C0.8 23.8667 0.666667 23.8667 0.4 24C0.133333 24.1333 0 24.4 0 24.5333V26.2667C0 29.3333 5.73333 31.7333 13.3333 31.7333C14.8 31.7333 16.2667 31.6 17.7333 31.4667C18 31.4667 18.1333 31.3333 18.2667 31.0667C18.4 30.8 18.2667 30.5333 18.1333 30.4C17.3333 29.3333 16.6667 28.2667 16.4 27.0667ZM24.6667 17.3333C20.6667 17.3333 17.3333 20.6667 17.3333 24.6667C17.3333 28.6667 20.6667 32 24.6667 32C28.6667 32 32 28.6667 32 24.6667C32 20.6667 28.6667 17.3333 24.6667 17.3333ZM29.2 22.5333L23.8667 27.8667C23.7333 28 23.4667 28 23.3333 28C23.2 28 22.9333 28 22.8 27.8667L20.1333 25.2C19.8667 24.9333 19.8667 24.5333 20.1333 24.2667C20.4 24 20.8 24 21.0667 24.2667L23.2 26.4L28 21.6C28.2667 21.3333 28.6667 21.3333 28.9333 21.6C29.3333 21.7333 29.3333 22.2667 29.2 22.5333ZM13.3333 25.3333H15.3333C15.7333 25.3333 16 25.0667 16 24.6667C16 23.3333 16.2667 22.1333 16.9333 20.9333C17.0667 20.6667 17.0667 20.4 16.9333 20.2667C16.8 20.1333 16.5333 20 16.2667 20C15.2 20 14.2667 20 13.3333 20C8.26667 20 3.73333 19.0667 1.06667 17.3333C0.8 17.2 0.666667 17.2 0.4 17.3333C0.133333 17.4667 0 17.7333 0 17.8667V20.6667C0 22.9333 5.33333 25.3333 13.3333 25.3333Z"
                    fill="#0F172A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_397_461">
                    <rect width="32" height="32" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            <h6 className="cardhead">Verified Share Data</h6>
            <p className="cardpara">
              Public companies publish verified share structure information
              including authorized shares, outstanding shares, and verified
              float data.
            </p>
          </motion.div>

          <motion.div className="innercard" variants={cardVariant}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M19.8125 1.93884H2.8125C1.25619 1.93884 0 3.19503 0 4.75134V16.0013C0 17.5575 1.25619 18.8138 2.8125 18.8138H3.75V21.6263C3.75 22.3037 4.45131 22.7942 5.1375 22.4513C5.15625 22.4326 5.19381 22.4326 5.21256 22.4138C10.3698 18.9553 9.214 19.7265 10.3688 18.9638C10.5188 18.87 10.6875 18.8138 10.875 18.8138H19.8125C21.3688 18.8138 22.625 17.5575 22.625 16.0013V4.75134C22.625 3.19503 21.3688 1.93884 19.8125 1.93884ZM12.3125 13.1888H4.6875C3.45169 13.1888 3.44662 11.3138 4.6875 11.3138H12.3125C13.5483 11.3138 13.5534 13.1888 12.3125 13.1888ZM17.9375 9.43884H4.6875C3.45169 9.43884 3.44662 7.56384 4.6875 7.56384H17.9375C19.1733 7.56384 19.1784 9.43884 17.9375 9.43884Z"
                  fill="#0F172A"
                />
                <path
                  d="M29.1875 9.43884H24.5V16.0013C24.5 18.5888 22.4 20.6888 19.8125 20.6888H11.1562L9.375 21.8701V23.5013C9.375 25.0575 10.6312 26.3138 12.1875 26.3138H21.4062L26.7874 29.9138C27.5219 30.3216 28.25 29.8257 28.25 29.1263V26.3138H29.1875C30.7438 26.3138 32 25.0575 32 23.5013V12.2513C32 10.6951 30.7438 9.43884 29.1875 9.43884Z"
                  fill="#0F172A"
                />
              </svg>
            <h6 className="cardhead">Verified Investor Discussions</h6>
            <p className="cardpara">
              Each ticker includes a dedicated chatboard where verified
              investors can discuss developments and insights.
            </p>
          </motion.div>

          <motion.div className="innercard" variants={cardVariant}>
             <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M16 25C16 20.589 19.589 17 24 17C24.692 17 25.359 17.097 26 17.263V6C26 3.239 23.761 1 21 1H9C6.239 1 4 3.239 4 6V23C4 25.761 6.239 28 9 28H16.589C16.212 27.073 16 26.061 16 25ZM9 6H17C17.553 6 18 6.448 18 7C18 7.552 17.553 8 17 8H9C8.447 8 8 7.552 8 7C8 6.448 8.447 6 9 6ZM9 11H21C21.553 11 22 11.448 22 12C22 12.552 21.553 13 21 13H9C8.447 13 8 12.552 8 12C8 11.448 8.447 11 9 11ZM12.38 23H9C8.447 23 8 22.552 8 22C8 21.448 8.447 21 9 21H12.38C12.933 21 13.38 21.448 13.38 22C13.38 22.552 12.933 23 12.38 23ZM15.07 18H9C8.447 18 8 17.552 8 17C8 16.448 8.447 16 9 16H15.07C15.623 16 16.07 16.448 16.07 17C16.07 17.552 15.623 18 15.07 18Z"
                  fill="#0F172A"
                />
                <path
                  d="M24 19C20.692 19 18 21.692 18 25C18 28.308 20.692 31 24 31C27.308 31 30 28.308 30 25C30 21.692 27.308 19 24 19ZM26.707 24.574L24.04 27.241C23.845 27.436 23.589 27.534 23.333 27.534C23.077 27.534 22.821 27.436 22.626 27.241L21.293 25.908C20.902 25.517 20.902 24.885 21.293 24.494C21.684 24.103 22.316 24.103 22.707 24.494L23.333 25.12L25.293 23.161C25.684 22.77 26.316 22.77 26.707 23.161C27.098 23.552 27.098 24.185 26.707 24.575V24.574Z"
                  fill="#0F172A"
                />
              </svg>
            <h6 className="cardhead">Transparent Trading Activity</h6>
            <p className="cardpara">
              TraqStock publishes transparent trading activity data and market
              behavior insights, giving investors greater visibility into how
              stocks are trading across the market.
            </p>
          </motion.div>

          <motion.div className="innercard" variants={cardVariant}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M16.0001 15.1821L29.1509 7.59269L16.0001 0L2.84912 7.59269L16.0001 15.1821Z"
                  fill="black"
                />
                <path
                  d="M15.0591 16.8116L1.9082 9.22229V24.4073L15.0591 32V16.8116Z"
                  fill="black"
                />
                <path
                  d="M16.9409 16.8116V32L30.0915 24.4073V9.22229L16.9409 16.8116Z"
                  fill="black"
                />
              </svg>
            <h6 className="cardhead">Blockchain Anchoring</h6>
            <p className="cardpara">
              Verified datasets are permanently recorded to the blockchain.
              Once published, records become timestamped, immutable, and
              independently verifiable, ensuring long-term transparency and
              data integrity.
            </p>
          </motion.div>

        </motion.div>
      </div>
    </section>
  );
};

export default Ourvision;
